import { useState } from 'react';
import { View, ActivityIndicator } from 'react-native';

import { Button, COLORS, Text, TextField } from '../Basics';
import { InputRow } from '../Forms';
import { Screen } from '../../screens/Screen';
import LorentzService from '../../services/LorentzService';

export const CtiTransferModal = ({ visible, onClose }) => {
  const [destination, setDestination] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleTransfer = async () => {
    setError('');
    setLoading(true);
    try {
      await LorentzService.transferTo(destination);
      setDestination('');
      onClose?.();
    } catch (err) {
      setError(err?.message || 'Falha na transferência');
    } finally {
      setLoading(false);
    }
  };

  if (!visible) return null;

  return (
    <Screen
      visible
      closeable
      onClose={onClose}
      color="rgba(0,0,0,0.45)"
      bodyStyle={{ justifyContent: 'center', alignItems: 'center' }}
    >
      <View
        style={{
          width: '90%',
          maxWidth: 320,
          backgroundColor: COLORS.app,
          borderRadius: 8,
          padding: 16
        }}
      >
        <Text style={{ fontSize: 16, fontWeight: 'bold', marginBottom: 12 }}>
          Transferir (CTI)
        </Text>
        <Text style={{ color: COLORS.textSecondary, marginBottom: 12, fontSize: 12 }}>
          Ramal ou grupo na central LorentzCTI
        </Text>

        <InputRow
          label="Destino"
          placeholder="Ex: 1002 ou código do grupo"
          value={destination}
          onChange={setDestination}
        />

        {error ? (
          <Text style={{ color: COLORS.danger, marginTop: 4 }}>{error}</Text>
        ) : null}

        <View style={{ flexDirection: 'row', marginTop: 16 }}>
          <Button onClick={onClose} style={{ marginRight: 8 }}>
            <Text>Cancelar</Text>
          </Button>
          <Button color="primary" style={{ flex: 1 }} onClick={handleTransfer}>
            {loading ? (
              <ActivityIndicator color="#fff" />
            ) : (
              <Text style={{ color: '#fff' }}>Transferir</Text>
            )}
          </Button>
        </View>
      </View>
    </Screen>
  );
};

export default CtiTransferModal;
